import { useAppDispatch } from './redux';
import {
  addToast,
  addSuccessToast,
  addErrorToast,
  addWarningToast,
  addInfoToast,
  removeToast,
  clearAllToasts,
  type AddToastPayload,
} from '../store/slices/toastSlice';

export const useToast = () => {
  const dispatch = useAppDispatch();

  const toast = {
    // Generic toast
    show: (payload: AddToastPayload) => {
      dispatch(addToast(payload));
    },

    // Specific toast types
    success: (title: string, message: string) => {
      dispatch(addSuccessToast({ title, message }));
    },

    error: (title: string, message: string) => {
      dispatch(addErrorToast({ title, message }));
    },

    warning: (title: string, message: string) => {
      dispatch(addWarningToast({ title, message }));
    },

    info: (title: string, message: string) => {
      dispatch(addInfoToast({ title, message }));
    },

    // Management functions
    dismiss: (id: string) => {
      dispatch(removeToast(id));
    },

    dismissAll: () => {
      dispatch(clearAllToasts());
    },
  };

  return toast;
};
